<script>
    import { RoundMock } from '@/components'

    export let items = []
    export let circleColor = '#000000'
    export let htmlStringMode = true
    export let title = null
</script>

{#if title}
    <h3 class="title" style={`color: ${circleColor};`}>{title}</h3>
{/if}
<ul class="wrapper">
    {#each items as item}
        <li class="item-wrapper">
            <div class="circle-wrapper">
                <div class="circle" style={`background-color: ${circleColor};`} />
                <RoundMock style="position: absolute; top: 0; right: 0; width: 17px; height: 17px;" />
            </div>    
            <div class="item-content">
                {#if !htmlStringMode}
                    {item}
                {:else}
                    {@html item}
                {/if}
            </div>
        </li>
    {/each}
</ul>

<style lang="scss" module>
    .title {
        font-size: 32px;
        line-height: 40px;
        display: block;
        margin-top: 30px;
    }

    .wrapper {
        font-size: 20px;
        line-height: 25px;

        li+li {
            margin-top: 14px;
        }

        .item-wrapper {
            display: flex;
            align-items: top;

            .circle-wrapper {
                position: relative;
                // width: 17px;
                // height: 17px;
                margin-right: 19px;

                .circle {
                    position: absolute;
                    top: -2px;
                    right: -2px;
                    width: 13px;
                    height: 13px;
                    border-radius: 100%;
                }
            }
        }
    }

    @media (max-width: 834px) {
        .item-content {
            br {
                display: none;
            }
        }
    }

    @media (max-width: 420px) {
        .title {
            font-size: 22px;
            line-height: 28px;
            margin-left: -20px;
            margin-bottom: 30px;
        }

        .wrapper {
            font-size: 14px;
            line-height: 18px;
        }
    }
</style>